var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_61_17749",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_61_17749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 15.55C11.8665 15.55 11.7415 15.5292 11.6248 15.4875C11.5081 15.4458 11.3998 15.375 11.2998 15.275L6.6998 10.675C6.51647 10.4917 6.4248 10.2583 6.4248 9.975C6.4248 9.69167 6.51647 9.45833 6.6998 9.275C6.88314 9.09167 7.11647 9 7.3998 9C7.68314 9 7.91647 9.09167 8.0998 9.275L11.9998 13.175L15.8998 9.275C16.0831 9.09167 16.3165 9 16.5998 9C16.8831 9 17.1165 9.09167 17.2998 9.275C17.4831 9.45833 17.5748 9.69167 17.5748 9.975C17.5748 10.2583 17.4831 10.4917 17.2998 10.675L12.6998 15.275C12.5998 15.375 12.4915 15.4458 12.3748 15.4875C12.2581 15.5292 12.1331 15.55 11.9998 15.55Z",
    fill: "#454E58"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.5db6b352a72523b6193c5949813f3654.svg";
export { ForwardRef as ReactComponent };